import styled from 'styled-components';

const PageWrapper = styled.div`
	display: flex;
	flex: 1;
	padding: 24px 15px;
	flex-direction: column;
	overflow: auto;
	position: relative;
	
	.user-tbl {
		.roe-card-style {
			margin-top: 15px;
			margin-bottom: 15px;

			.react-table-header-class {
				font-weight: 600;
				font-size: 14px;
				color: #788195;
			}

			.module-header {
				padding: 10px 20px;
				border-bottom: 1px solid #e9e9e9;
				display: flex;
				align-items: center;
				
				.fs-16 {
					font-size: 16px;
				}
				
				.demi-bold-text {
					font-weight: 600;
				}
			}

			.roe-card-body {
				padding: 20px;
			}
		}
	}

	.custom-react-table-theme-class {
		.rt-tbody {
			.rt-td {
				font-family: 'montserrat-medium';
				color: #757575;
			}
		}
	}

	.Table__itemCount {
		font-size: 14px;
	}

	.Table__pagination {
		display: flex;
		justify-content: flex-end;
		padding: 20px 10px 0px;
	}

	.Table__pageButton {
		font-size: 18px;
		outline: none;
		border: none;
		background-color: transparent;
		cursor: pointer;
		color: #ff67678c !important;
		margin: 0 5px;
	}

	.Table__pageButton:disabled {
		cursor: not-allowed;
		color: gray;
	}

	.Table__pageButton--active {
		font-weight: bold;
		background: #ff6767;
		color: white !important;
		width: 30px;
		height: 30px;
		border-radius: 6px;
	}

	.tabl-search {
		&:focus {
			outline: 0;
		}
	}

	.back-icon {
		position: absolute;
		right: 15px;
		bottom: 20px;
		color: ${(props) => props.sidebarTheme.activeColor};
	}

	.-sort-desc {
		box-shadow: none !important;
		&:before {
			content: '▼';
			float: right;
			margin-right: 14px;
			color: ${(props) => props.sidebarTheme.activeColor};
		}
	}

	.-sort-asc {
		box-shadow: none !important;
		&:before {
			content: '▲';
			float: right;
			margin-right: 14px;
			color: ${(props) => props.sidebarTheme.activeColor};
		}
	}

	.advertisement-form {
		.form-group {
			margin-bottom: 20px;
			
			label {
				font-weight: 600;
				margin-bottom: 8px;
				display: block;
				color: #788195;
			}
			
			.form-control {
				border: 1px solid #e9e9e9;
				border-radius: 4px;
				padding: 10px 12px;
				font-size: 14px;
				
				&:focus {
					border-color: #2563eb;
					box-shadow: 0 0 0 0.2rem rgba(37, 99, 235, 0.25);
				}
			}
			
			.file-upload {
				border: 2px dashed #e9e9e9;
				border-radius: 8px;
				padding: 20px;
				text-align: center;
				cursor: pointer;
				transition: border-color 0.3s;
				
				&:hover {
					border-color: #2563eb;
				}
				
				&.drag-over {
					border-color: #2563eb;
					background-color: rgba(37, 99, 235, 0.05);
				}
			}
		}
		
		.media-preview {
			margin-top: 15px;
			
			img, video {
				max-width: 200px;
				max-height: 200px;
				border-radius: 8px;
				border: 1px solid #e9e9e9;
			}
		}
		
		.event-associations {
			.event-item {
				display: flex;
				align-items: center;
				padding: 8px 12px;
				margin: 4px 0;
				background-color: #f8f9fa;
				border-radius: 4px;
				border: 1px solid #e9e9e9;
				
				.event-name {
					flex: 1;
					font-size: 14px;
				}
				
				.remove-btn {
					background: none;
					border: none;
					color: #dc3545;
					cursor: pointer;
					padding: 4px;
					
					&:hover {
						color: #c82333;
					}
				}
			}
		}
	}

	.advertisement-preview {
		background: #ffffff;
		border-radius: 12px;
		overflow: hidden;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
		
		.preview-header {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			padding: 20px 25px;
			color: white;
			
			.preview-title {
				margin: 0;
				font-size: 20px;
				font-weight: 600;
				display: flex;
				align-items: center;
				
				i {
					margin-right: 10px;
					font-size: 18px;
				}
			}
		}
		
		.preview-content {
			padding: 25px;
			display: flex;
			gap: 30px;
			flex-wrap: wrap;
			
			@media (max-width: 768px) {
				flex-direction: column;
				gap: 20px;
			}
		}
		
		.details-section {
			flex: 1;
			min-width: 300px;
			
			.details-info {
				background: #f8f9fa;
				border-radius: 10px;
				padding: 20px;
				margin-bottom: 20px;
				box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
				
				.field {
					display: flex;
					margin-bottom: 15px;
					align-items: flex-start;
					
					&:last-child {
						margin-bottom: 0;
					}
					
					.label {
						font-weight: 600;
						color: #495057;
						min-width: 120px;
						margin-right: 15px;
						font-size: 14px;
					}
					
					.value {
						flex: 1;
						color: #212529;
						font-size: 14px;
						line-height: 1.5;
						
						&.active {
							color: #28a745;
							font-weight: 600;
						}
						
						&.inactive {
							color: #dc3545;
							font-weight: 600;
						}
					}
				}
			}
			
			.events-section {
				background: #f8f9fa;
				border-radius: 10px;
				padding: 20px;
				box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
				
				.events-title {
					font-weight: 600;
					color: #495057;
					font-size: 14px;
					margin-bottom: 15px;
					display: block;
				}
				
				.events-list {
					list-style: none;
					padding: 0;
					margin: 0;
					
					.event-item {
						padding: 8px 12px;
						margin-bottom: 8px;
						background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
						color: white;
						border-radius: 20px;
						font-size: 12px;
						font-weight: 500;
						box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
						transition: all 0.3s ease;
						display: flex;
						align-items: center;
						
						&:last-child {
							margin-bottom: 0;
						}
						
						i {
							margin-right: 8px;
							font-size: 10px;
							opacity: 0.8;
						}
						
						&:hover {
							transform: translateY(-2px);
							box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
						}
					}
				}
			}
		}
		
		.details-table-container {
			background: #f8f9fa;
			border-radius: 10px;
			padding: 20px;
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
		}
		
		.details-table {
			width: 100%;
			border-collapse: collapse;
			background: white;
			border-radius: 8px;
			overflow: hidden;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
			
			tbody tr {
				border-bottom: 1px solid #e9ecef;
				transition: background-color 0.2s ease;
				
				&:hover {
					background-color: #f8f9fa;
				}
				
				&:last-child {
					border-bottom: none;
				}
			}
			
			td {
				padding: 15px 18px;
				vertical-align: top;
			}
			
			.label {
				width: 40%;
				font-weight: 600 !important;
				color: #212529 !important;
				background-color: #f8f9fa !important;
				border-right: 3px solid #e9ecef;
				
				i {
					margin-right: 8px;
					width: 16px;
					text-align: center;
				}
				
				span {
					font-size: 14px !important;
					color: #212529 !important;
					font-weight: 600 !important;
				}
				
				&.events-label {
					.events-count {
						margin-left: 5px;
						font-size: 12px;
						color: #6c757d;
						font-weight: 500;
						background: #e9ecef;
						padding: 2px 6px;
						border-radius: 10px;
					}
				}
			}
			
			.value {
				color: #212529 !important;
				font-size: 14px !important;
				line-height: 1.5 !important;
				font-weight: 500 !important;
				
				&.file-name {
					font-family: 'Courier New', monospace !important;
					background: #f1f3f4 !important;
					padding: 4px 8px !important;
					border-radius: 4px !important;
					font-size: 13px !important;
					color: #495057 !important;
					font-weight: 500 !important;
				}
			}
		}
		
		.media-type-badge {
			padding: 6px 12px;
			border-radius: 20px;
			font-size: 11px;
			font-weight: 600;
			text-transform: uppercase;
			letters-spacing: 0.5px;
			background: linear-gradient(135deg, #ff9a56 0%, #ff6b95 100%);
			color: white;
			box-shadow: 0 2px 8px rgba(255, 107, 149, 0.3);
		}
		
		.status-badge {
			padding: 6px 12px;
			border-radius: 20px;
			font-size: 11px;
			font-weight: 600;
			text-transform: uppercase;
			letters-spacing: 0.5px;
			
			&.active {
				background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
				color: white;
				box-shadow: 0 2px 8px rgba(79, 172, 254, 0.3);
			}
			
			&.inactive {
				background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
				color: white;
				box-shadow: 0 2px 8px rgba(250, 112, 154, 0.3);
			}
		}
		
		.preview-media {
			background: #f8f9fa;
			border-radius: 10px;
			padding: 20px;
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
			height: fit-content;
			
			.media-header {
				margin-bottom: 20px;
				
				h5 {
					margin: 0;
					color: #495057;
					font-weight: 600;
					font-size: 16px;
					display: flex;
					align-items: center;
					
					i {
						margin-right: 8px;
						color: #6c757d;
					}
				}
			}
			
			.media-container {
				display: flex !important;
				justify-content: center !important;
				align-items: center !important;
				min-height: 200px !important;
				max-height: 320px !important;
				background: white !important;
				border-radius: 8px !important;
				padding: 15px !important;
				box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
				overflow: hidden !important;
				position: relative !important;
			}
			
			.preview-image, .preview-video {
				max-width: 280px;
				max-height: 280px;
				width: auto;
				height: auto;
				object-fit: contain;
				display: block;
				margin: 0 auto;
				border-radius: 8px;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				transition: transform 0.3s ease;
				
				&:hover {
					transform: scale(1.02);
				}
			}
			
			.no-preview, .no-media {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				min-height: 200px;
				color: #adb5bd;
				background: white;
				border-radius: 8px;
				border: 2px dashed #dee2e6;
				
				i {
					font-size: 48px;
					margin-bottom: 10px;
					opacity: 0.5;
				}
				
				p {
					margin: 0;
					font-size: 14px;
					font-weight: 500;
				}
			}
		}
		
		.associated-events-list {
			display: flex;
			flex-direction: column;
			gap: 8px;
			margin-top: 5px;
			
			.event-tag {
				display: inline-flex;
				align-items: center;
				padding: 8px 12px;
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				color: white;
				border-radius: 20px;
				font-size: 12px;
				font-weight: 500;
				text-transform: capitalize;
				box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
				transition: all 0.3s ease;
				
				i {
					margin-right: 6px;
					font-size: 10px;
					opacity: 0.8;
				}
				
				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
				}
			}
		}
		
		.modal-footer {
			padding: 20px 25px;
			border-top: 1px solid #e9ecef;
			background: #f8f9fa;
			display: flex;
			justify-content: flex-end;
			
			.btn {
				padding: 10px 20px;
				border-radius: 25px;
				border: none;
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				color: white;
				cursor: pointer;
				font-weight: 500;
				font-size: 14px;
				transition: all 0.3s ease;
				box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
				display: flex;
				align-items: center;
				
				i {
					margin-right: 8px;
				}
				
				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
				}
				
				&:active {
					transform: translateY(0);
				}
			}
		}
	}
`;

export default PageWrapper;
